namespace Vit {
    export enum NodeType {
        Root = 1,
        UI,
        Enum,
        UIField,
        EnumItem,
        EnumField,
        Lookup,
        Other,
    }

    export interface SergenUIInfo {
        Name: string;
        DefaultGrid?: SergenUIModelInfo;
        DefaultForm?: SergenUIModelInfo;
        Permission?: string;
        UIModels?: SergenUIModelInfo[];
        LookupModels?: SergenLookupModelInfo[];

        GLobals?: GlobalModuleModel;
    }

    export interface SergenUIModelInfo {
        Name: string;
        UIType: UIType;
        Fields: SergenFieldInfo[];

        MenuNavigationLink?: string;
        MenuNavigationIcon?: string;
        MenuNavigationAction?: string;
    }
    export interface SergenLookupModelInfo {
        Name: string;
        LookupType: LookupTypeEnum;

        Columns: SergenGridFieldInfo[];
        LookupDisplayExpression: string;
        LookupDisplayColumn: string;
    }


    export enum LookupTypeEnum {
        ClientSide = 1,
        ServerSide = 2,
    }
    export interface GlobalModuleModel {
        Enums?: EnumModel[];
        Lookups?: LookupModelInfo[];
    }
    export interface LookupModelInfo {
        SchemaName: string;
        TableName: string;
        PKType: string;
        Lookup: LookupModelName;
    }
    export interface LookupModelName {
        Name: string;
    }
    export interface EnumModel {
        Name?: string;
        Items?: EnumItem[];
    }

    export interface EnumItem {
        Name?: string;
        Comment?: string;
        Value?: number;
    }

    export enum Visibility {
        None = 0,
        Hidden = 1,
        Visible = 2,
    }

    export interface SergenFieldInfo {
        DataType: FieldType;
        FieldType: FieldType;
        Visible: Visibility;
        Name: string;
        Order: number;
        DisplayName: string;
        Width?: string;
        Ignore: boolean;
        IgnoreName: boolean;
        AlignRight: boolean;

        IsDetail: boolean;
        DetailTableName?: string;
    }

    export interface SergenGridFieldInfo extends SergenFieldInfo {
        EditLink: boolean;
        Hidden: boolean;
        Sortable: boolean;
        Resizable: boolean;
        AllowHide: boolean;
        QuickFilter: boolean;
        NotFilterable: boolean;
        GridFormatter?: GridFormatter;

        Source?: string;
        JoinInfo?: IJoinInfo;

        Fields?: SergenGridFieldInfo[];
    }

    export interface IJoinInfo {
        Name: string;
        SourceField: string;
    }

    export interface SergenFormFieldInfo extends SergenFieldInfo {
        Required: boolean;
        InsertableAttrib: boolean;
        UpdatableAttrib: boolean;
        Placeholder?: string;
        Editor?: FormEditorType;
        EditorType?: string;
        HideOnInsert: boolean;
        HideOnUpdate: boolean;
        OneWay: boolean;
        Category?: string;
        Tab?: string;
        LabelWidth?: string;
        MaxLength?: string;
        PropWidth?: PropWidth;

        PKSchema?: string;
        PKTable?: string;

        GridEditorType?: any;
    }

    export enum UIType {
        GridUI = 1,
        FormUI = 2,
    }

    export enum GridFormatter {
        BooleanFormatter = 1,
        DateFormatter = 2,
        DateTimeFormatter = 3,
        EnumFormatter = 4,
        NumberFormatter = 5,
        FileDownloadFormatter = 6,
        MinuteFormatter = 7,
        UrlFormatter = 8,
    }

    export enum FieldType {
        String = "String", //0,
        Int16 = "Int16", //1,
        Int32 = "Int32", //2,
        Int64 = "Int64", //3,
        Boolean = "Boolean", //4,
        Decimal = "Decimal", //5,
        Single = "Single", //6,
        Double = "Double", //7,
        DateTime = "DateTime", //8,
        Time = "Time", //9,
        TimeStamp = "TimeStamp", //9,
        Guid = "Guid", //10,
        Stream = "Stream", //11,
        Object = "Object", //12,
    }

    export enum FormEditorType {
        StringEditor = 1,
        TextAreaEditor = 2,
        EmailEditor = 3,
        EmailAddressEditor = 4,
        PasswordEditor = 5,
        URLEditor = 6,
        BooleanEditor = 7,
        IntegerEditor = 8,
        DecimalEditor = 9,
        DateEditor = 10,
        TimeEditor = 11,
        DateTimeEditor = 12,
        // DateYearEditor = 13,
        RadioButtonEditor = 14,
        LookupEditor = 15,
        FileUploadEditor = 16,
        MultipleFileUploadEditor = 17,
        ImageUploadEditor = 18,
        MultipleImageUploadEditor = 19,
        MapEditor = 20,
        GridEditor = 30,
    }

    export class EnumHelper {
        static GetPropWidth(prop: PropWidth): string {
            switch (prop) {
                case PropWidth.QuarterWidth:
                    return "col-sm-3";
                case PropWidth.OneThirdWidth:
                    return "col-sm-4";
                case PropWidth.TwoThirdWidth:
                    return "col-sm-8";
                case PropWidth.HalfWidth:
                    return "col-sm-6";
                case PropWidth.FullWidth:
                    return "col-sm-12";
                case PropWidth.MediumQuarterWidth:
                    return "col-md-3";
                case PropWidth.MediumHalfWidth:
                    return "col-md-6";
                case PropWidth.MediumThirdLargeQuarterWidth:
                    return "col-md-4 col-lg-3";
                case PropWidth.MediumHalfLargeQuarterWidth:
                    return "col-md-6 col-lg-3";
                case PropWidth.MediumHalfLargeThirdWidth:
                    return "col-md-6 col-lg-4";
            }
        }
    }

    export enum PropWidth {
        QuarterWidth = 1, // "formCssClass":"col-sm-3"
        OneThirdWidth = 2, // "formCssClass":"col-sm-4"
        TwoThirdWidth = 3, // "formCssClass":"col-sm-8"
        HalfWidth = 4, // "formCssClass":"col-sm-6"
        FullWidth = 5, // "formCssClass":"col-sm-12"
        MediumQuarterWidth = 6, // "formCssClass": "col-md-3"
        MediumHalfWidth = 7, // "formCssClass": "col-md-6"
        MediumThirdLargeQuarterWidth = 8, // "formCssClass":"col-md-4 col-lg-3"
        MediumHalfLargeQuarterWidth = 9, // "formCssClass":"col-md-6 col-lg-3"
        MediumHalfLargeThirdWidth = 10, // "formCssClass":"col-md-6 col-lg-4"
    }
}